/* eslint-disable */
import { useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Slider, Typography } from "@mui/material";

const ASPECT = 1400 / 840; // 5:3

function getCroppedImg(imageSrc, pixelCrop) {
  return new Promise((resolve) => {
    const image = new Image();
    image.crossOrigin = "anonymous";
    image.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = 1400;
      canvas.height = 840;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(
        image,
        pixelCrop.x,
        pixelCrop.y,
        pixelCrop.width,
        pixelCrop.height,
        0,
        0,
        1400,
        840
      );
      resolve(canvas.toDataURL("image/jpeg", 0.9));
    };
    image.src = imageSrc;
  });
}

export default function ImageCropper({ open, imageSrc, onClose, onCropDone }) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const onCropComplete = useCallback((_, croppedPixels) => {
    setCroppedAreaPixels(croppedPixels);
  }, []);

  const handleDone = async () => {
    if (!croppedAreaPixels) return;
    const croppedBase64 = await getCroppedImg(imageSrc, croppedAreaPixels);
    onCropDone(croppedBase64);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: "12px" } }}>
      <DialogTitle>
        <Typography variant="h6" fontWeight={600}>Crop Featured Image</Typography>
        <Typography variant="caption" color="text.secondary">Adjust the visible area (1400 × 840)</Typography>
      </DialogTitle>
      <DialogContent sx={{ p: 0, position: "relative", height: 400, backgroundColor: "#111" }}>
        <Cropper
          image={imageSrc}
          crop={crop}
          zoom={zoom}
          aspect={ASPECT}
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropComplete={onCropComplete}
        />
      </DialogContent>
      <Box sx={{ px: 3, pt: 2 }}>
        <Typography variant="body2" color="text.secondary" gutterBottom>Zoom</Typography>
        <Slider value={zoom} min={1} max={3} step={0.1} onChange={(_, v) => setZoom(v)} />
      </Box>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} sx={{ textTransform: "none" }}>Cancel</Button>
        <Button variant="contained" onClick={handleDone} sx={{ textTransform: "none", fontWeight: 600 }}>
          Crop & Use
        </Button>
      </DialogActions>
    </Dialog>
  );
}
